import React from 'react';

type LoaderProps = { className?: string };

const Loader: React.FC<LoaderProps> = ({ className }) => (
  <div className={`flex items-center justify-center ${className || ''}`}>
    <div className="animate-spin h-6 w-6 border-2 border-gray-300 border-t-transparent rounded-full" />
  </div>
);

export default Loader;
